import React, { useState } from "react";
import "./VirasatDefaultV2PageWrapper.scss"
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import LeftDrawer from "./components/LeftDrawer/LeftDrawer";
import ComingSoonModal from "./components/ComingSoonModal/ComingSoonModal";
import { useSelector } from "react-redux";

const VirasatDefaultV2PageWrapper = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const iscoming = useSelector((state) => state.companyData.isComing)
    return (
        <div className="VirasatDefaultV2PageWrapper">
            <LeftDrawer
                isOpen={isMenuOpen}
                setIsOpen={setIsMenuOpen} />
            <Navbar
                setIsMenuOpen={setIsMenuOpen} />
            {children}
            {iscoming && <ComingSoonModal />}
            <Footer />
        </div>
    )
}
export default VirasatDefaultV2PageWrapper